/**
 * Tracks whether the most recent user interaction was keyboard-driven, so focus rings can be
 * shown only for keyboard navigation (mirrors the WICG :focus-visible polyfill approach).
 * Capture-phase listeners so a descendant's stopPropagation() can't hide a pointer interaction.
 */
let hadKeyboardEvent = false;
let listenersAttached = false;

function onKeyDown(event: KeyboardEvent) {
    if (!event.metaKey && !event.altKey && !event.ctrlKey) {
        hadKeyboardEvent = true;
    }
}

function onPointerDown() {
    hadKeyboardEvent = false;
}

function ensureListeners() {
    if (listenersAttached || typeof window === "undefined") {
        return;
    }
    listenersAttached = true;
    window.addEventListener("keydown", onKeyDown, true);
    window.addEventListener("mousedown", onPointerDown, true);
    window.addEventListener("pointerdown", onPointerDown, true);
    window.addEventListener("touchstart", onPointerDown, true);
}

ensureListeners();

export function wasLastInteractionKeyboard(): boolean {
    return hadKeyboardEvent;
}
